import PrivateHeader from '@/components/common/Header/PrivateHeader';
import { Outlet } from 'react-router-dom';

const PrivateLayout = () => {
  return (
    <div className='flex flex-col bg-bgPrimary h-screen overflow-auto pb-10'>
      <PrivateHeader />
      <Outlet />
    </div>
  );
};
export default PrivateLayout;
